import _toConsumableArray from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _toArray from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toArray";
import _slicedToArray from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _createForOfIteratorHelper from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _asyncToGenerator from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

import { ethers } from 'ethers';
import { addressesEqual, includesAddress, ANY_ENTITY } from '../address';
import { isFullMethodSignature } from '../app';
import { encodeCallScript } from '../callScript';
import { canForward } from '../forwarding';
import { createDirectTransactionForApp, createForwarderTransactionBuilder, buildForwardingFeePretransaction } from '../transactions';

function validateMethod(destination, methodSignature, destinationApp) {
  var methods = destinationApp.intents;

  if (!methods) {
    throw new Error("No functions specified in artifact for ".concat(destination));
  } // Find the relevant method information


  var method = methods.find(function (method) {
    return isFullMethodSignature(methodSignature) ? method.sig === methodSignature : // If the full signature isn't given, just select the first overload declared
    method.sig.split('(')[0] === methodSignature;
  });

  if (!method) {
    throw new Error("No method named ".concat(methodSignature, " on ").concat(destination));
  }

  return method;
}
/**
 * Calculate the forwarding path for a transaction to `destination`
 * that invokes `directTransaction`.
 *
 */


function calculateForwardingPath(_x, _x2, _x3, _x4, _x5) {
  return _calculateForwardingPath.apply(this, arguments);
}
/**
 * Calculate the transaction path for a transaction to `destination`
 * that invokes `methodSignature` with `params`.
 *
 */


function _calculateForwardingPath() {
  _calculateForwardingPath = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(sender, directTransaction, forwardersWithPermission, forwarders, provider) {
    var createForwarderTransaction, _iterator, _step, forwarder, script, transaction, forwardingFeePretransaction, filterForwarders, queue, _loop, _ret;

    return _regeneratorRuntime().wrap(function _callee$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!(forwardersWithPermission.length === 0)) {
              _context2.next = 2;
              break;
            }

            return _context2.abrupt("return", {
              path: []
            });

          case 2:
            createForwarderTransaction = createForwarderTransactionBuilder(sender, directTransaction); // Check if one of the forwarders that has permission to perform an action
            // with `sig` on `address` can forward for us directly

            _iterator = _createForOfIteratorHelper(forwardersWithPermission);
            _context2.prev = 4;

            _iterator.s();

          case 6:
            if ((_step = _iterator.n()).done) {
              _context2.next = 25;
              break;
            }

            forwarder = _step.value;
            script = encodeCallScript([directTransaction]);
            _context2.next = 11;
            return canForward(forwarder, sender, script, provider);

          case 11:
            if (!_context2.sent) {
              _context2.next = 23;
              break;
            }

            transaction = createForwarderTransaction(forwarder, script);
            _context2.prev = 13;
            _context2.next = 16;
            return buildForwardingFeePretransaction(transaction, provider);

          case 16:
            forwardingFeePretransaction = _context2.sent;
            return _context2.abrupt("return", {
              forwardingFeePretransaction: forwardingFeePretransaction,
              path: [transaction, directTransaction]
            });

          case 20:
            _context2.prev = 20;
            _context2.t0 = _context2["catch"](13);
            return _context2.abrupt("return", {
              path: []
            });

          case 23:
            _context2.next = 6;
            break;

          case 25:
            _context2.next = 30;
            break;

          case 27:
            _context2.prev = 27;
            _context2.t1 = _context2["catch"](4);

            _iterator.e(_context2.t1);

          case 30:
            _context2.prev = 30;

            _iterator.f();

            return _context2.finish(30);

          case 33:
            // Get a list of all forwarders (excluding the forwarders with direct permission)
            filterForwarders = forwarders.filter(function (forwarder) {
              return !includesAddress(forwardersWithPermission, forwarder);
            }); // Set up the path finding queue
            // The queue takes the form of Array<[Array<EthereumTransaction>, Array<String>]>
            // In other words: it is an array of tuples, where the first index of the tuple
            // is the current path and the second index of the tuple is the
            // queue (a list of unexplored forwarder addresses) for that path

            queue = forwardersWithPermission.map(function (forwarderWithPermission) {
              // TODO: Fix types (type queue = [DirectTransaction[], string[]][])
              return [[createForwarderTransaction(forwarderWithPermission, encodeCallScript([directTransaction])), directTransaction], filterForwarders];
            }); // Find the shortest path via a breadth-first search of forwarder paths.
            // We do a breadth-first instead of depth-first search because:
            //   - We assume that most forwarding paths will be quite short, so it should be faster
            //     to check in "stages" rather than exhaust single paths
            //   - We don't currently protect against cycles in the path, and so exhausting single
            //     paths can be wasteful if they result in dead ends
            // TODO: We should find and return multiple paths

            _loop = /*#__PURE__*/_regeneratorRuntime().mark(function _loop() {
              var _queue$shift, _queue$shift2, path, _queue$shift2$, forwarder, nextQueue, previousForwarder, script, _transaction, _forwardingFeePretransaction;

              return _regeneratorRuntime().wrap(function _loop$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _queue$shift = queue.shift(), _queue$shift2 = _slicedToArray(_queue$shift, 2), path = _queue$shift2[0], _queue$shift2$ = _toArray(_queue$shift2[1]), forwarder = _queue$shift2$[0], nextQueue = _queue$shift2$.slice(1); // Skip if no forwarder or the path is longer than 5

                      if (!(!forwarder || path.length > 5)) {
                        _context.next = 3;
                        break;
                      }

                      return _context.abrupt("return", "continue");

                    case 3:
                      // Get the previous forwarder address
                      previousForwarder = path[0].to; // Encode the previous transaction into an EVM callscript

                      script = encodeCallScript([path[0]]);
                      _context.next = 7;
                      return canForward(previousForwarder, forwarder, script, provider);

                    case 7:
                      if (!_context.sent) {
                        _context.next = 25;
                        break;
                      }

                      _context.next = 10;
                      return canForward(forwarder, sender, script, provider);

                    case 10:
                      if (!_context.sent) {
                        _context.next = 24;
                        break;
                      }

                      // The previous forwarder can forward a transaction for this forwarder,
                      // and this forwarder can forward for our address, so we have found a path
                      _transaction = createForwarderTransaction(forwarder, script); // Only apply pretransactions to the first transaction in the path
                      // as it's the only one that will be executed by the user

                      _context.prev = 12;
                      _context.next = 15;
                      return buildForwardingFeePretransaction(_transaction, provider);

                    case 15:
                      _forwardingFeePretransaction = _context.sent;
                      return _context.abrupt("return", {
                        v: {
                          forwardingFeePretransaction: _forwardingFeePretransaction,
                          path: [_transaction].concat(_toConsumableArray(path))
                        }
                      });

                    case 19:
                      _context.prev = 19;
                      _context.t0 = _context["catch"](12);
                      return _context.abrupt("return", {
                        v: {
                          path: []
                        }
                      });

                    case 22:
                      _context.next = 25;
                      break;

                    case 24:
                      // The previous forwarder can forward a transaction for this forwarder,
                      // but this forwarder can not forward for our address, so we add it as a
                      // possible path in the queue for later exploration.
                      queue.push([[createForwarderTransaction(forwarder, script)].concat(_toConsumableArray(path)), // Avoid including the current forwarder as a candidate for the next step
                      // in the path. Note that this is naive and may result in repeating cycles,
                      // but the maximum path length would prevent against infinite loops
                      forwarders.filter(function (nextForwarder) {
                        return nextForwarder !== forwarder;
                      })]);

                    case 25:
                      // We add the current path on the back of the queue again, but we shorten
                      // the list of possible forwarders.
                      queue.push([path, nextQueue]);

                    case 26:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _loop, null, [[12, 19]]);
            });

          case 36:
            return _context2.delegateYield(_loop(), "t2", 37);

          case 37:
            _ret = _context2.t2;

            if (!(_ret === "continue")) {
              _context2.next = 40;
              break;
            }

            return _context2.abrupt("continue", 42);

          case 40:
            if (!(typeof _ret === "object")) {
              _context2.next = 42;
              break;
            }

            return _context2.abrupt("return", _ret.v);

          case 42:
            if (queue.length) {
              _context2.next = 36;
              break;
            }

          case 43:
            return _context2.abrupt("return", {
              path: []
            });

          case 44:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee, null, [[4, 27, 30, 33], [13, 20]]);
  }));
  return _calculateForwardingPath.apply(this, arguments);
}

export function calculateTransactionPath(_x6, _x7, _x8, _x9, _x10, _x11, _x12) {
  return _calculateTransactionPath.apply(this, arguments);
}

function _calculateTransactionPath() {
  _calculateTransactionPath = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(sender, destination, methodSignature, params, apps, provider, finalForwarder //Address of the final forwarder that can perfom the action. Needed for actions that aren't in the ACL but whose execution depends on other factors
  ) {
    var _a, destinationApp, method, finalForwarderProvided, directTransaction, forwarders, forwardersWithPermission, role, allowedEntities;

    return _regeneratorRuntime().wrap(function _callee2$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            // Get the destination app
            destinationApp = apps.find(function (app) {
              return app.address == destination;
            });

            if (destinationApp) {
              _context3.next = 3;
              break;
            }

            throw new Error("Transaction path destination (".concat(destination, ") is not an installed app"));

          case 3:
            // Make sure the method signature is correct
            method = validateMethod(destination, methodSignature, destinationApp);
            finalForwarderProvided = finalForwarder ? ethers.utils.isAddress(finalForwarder) : false;
            _context3.next = 7;
            return createDirectTransactionForApp(sender, destinationApp, method.sig, params);

          case 7:
            directTransaction = _context3.sent;

            if (!(method.roles.length === 0 && !finalForwarderProvided || finalForwarder && addressesEqual(finalForwarder, sender))) {
              _context3.next = 16;
              break;
            }

            _context3.prev = 9;
            return _context3.abrupt("return", {
              path: [directTransaction]
            });

          case 13:
            _context3.prev = 13;
            _context3.t0 = _context3["catch"](9);
            return _context3.abrupt("return", {
              path: []
            });

          case 16:
            // Failing this, attempt transaction pathing algorithm with forwarders
            forwarders = apps.filter(function (app) {
              return app.isForwarder === true;
            }).map(function (app) {
              return app.address;
            });
            forwardersWithPermission = [];

            if (!finalForwarderProvided) {
              _context3.next = 25;
              break;
            }

            if (!finalForwarder) {
              _context3.next = 23;
              break;
            }

            if (includesAddress(forwarders, finalForwarder)) {
              _context3.next = 22;
              break;
            }

            return _context3.abrupt("return", {
              path: []
            });

          case 22:
            // Only attempt to find path with declared final forwarder; assume the final forwarder
            // is able to invoke the action
            forwardersWithPermission = [finalForwarder];

          case 23:
            _context3.next = 39;
            break;

          case 25:
            _context3.next = 27;
            return destinationApp.roles();

          case 27:
            role = _context3.sent.find(function (role) {
              return role.name === method.roles[0];
            });
            allowedEntities = ((_a = role === null || role === void 0 ? void 0 : role.permissions) === null || _a === void 0 ? void 0 : _a.map(function (permission) {
              return permission.granteeAddress;
            })) || []; // No one has access, so of course we don't as well

            if (!(allowedEntities.length === 0)) {
              _context3.next = 31;
              break;
            }

            return _context3.abrupt("return", {
              path: []
            });

          case 31:
            if (!(includesAddress(allowedEntities, sender) || includesAddress(allowedEntities, ANY_ENTITY))) {
              _context3.next = 38;
              break;
            }

            _context3.prev = 32;
            return _context3.abrupt("return", {
              path: [directTransaction]
            });

          case 36:
            _context3.prev = 36;
            _context3.t1 = _context3["catch"](32);

          case 38:
            // Find forwarders with permission to perform the action
            forwardersWithPermission = forwarders.filter(function (forwarder) {
              return includesAddress(allowedEntities, forwarder);
            });

          case 39:
            return _context3.abrupt("return", calculateForwardingPath(sender, directTransaction, forwardersWithPermission, forwarders, provider));

          case 40:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee2, null, [[9, 13], [32, 36]]);
  }));
  return _calculateTransactionPath.apply(this, arguments);
}